__turbopack_context__.v({
  "spin": "VFwPQq_spin",
  "spinner": "VFwPQq_spinner",
});
